module.exports = __webpack_public_path__ + "img/图片1.fd03cbd1.png";